<template>
  <div>
    <UIFormItem
      :label="$t('settings.calendar.scheduling_link')"
      :show-feedback="false"
    >
      <UIInput
        id="scheduling-link-input"
        v-model="scheduleLink"
        class="mr-2 !w-9/12"
        :readonly="true"
        size="medium"
        :disabled="true"
      />
      <UIButton
        id="copySchedulingLinkButton"
        type="primary"
        size="small"
        class="!w-3/12 bg-gray-300"
        @click="methods.copySchedulingLink"
        :disabled="data?.isSaving"
        ><Copy01Icon class="mr-2 h-4 w-4" />{{
          $t('settings.calendar.copy')
        }}</UIButton
      >
    </UIFormItem>
    <div class="py-4 text-sm text-gray-500">
      {{ $t('settings.calendar.share_schedule_link') }}
    </div>
  </div>
  <div class="mt-4 pt-4">
    <UIFormItem
      :label="$t('settings.calendar.permanent_link')"
      :show-feedback="false"
    >
      <UIInput
        id="scheduling-link-input"
        v-model="permanentLink"
        class="mr-2 !w-9/12"
        :readonly="true"
        size="medium"
        :disabled="true"
      />
      <UIButton
        id="copyPermanentLinkButton"
        type="primary"
        size="small"
        class="!w-3/12"
        @click="methods.copyPermanentLink"
        :disabled="data?.isSaving"
        ><Copy01Icon class="mr-2 h-4 w-4" />{{
          $t('settings.calendar.copy')
        }}</UIButton
      >
    </UIFormItem>
    <div class="py-4 text-sm text-gray-500">
      {{ $t('settings.calendar.share_permanent_link') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { Copy01Icon } from '@gohighlevel/ghl-icons/24/outline'
import {
  UIButton,
  UIFormItem,
  UIInput,
  useNotification,
} from '@gohighlevel/ghl-ui'
import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import AppState from '../../../states/app'
import { ICalendarShare } from '../../../types'
import { copyToClipboard } from '../../../utils/generalFunctions'
const notification = useNotification()
const { t } = useI18n()

const props = defineProps({
  data: {
    type: Object as PropType<ICalendarShare>,
    default: null,
  },
})

const scheduleLink = computed(() => {
  return `${AppState?.baseUrl}/widget/${props.data?.schedulePath}/${props.data?.slug}`
})

const permanentLink = computed(() => {
  return `${AppState?.baseUrl}/widget/${props.data?.permanentPath}/${props.data?.id}`
})

const methods = {
  async copySchedulingLink() {
    copyToClipboard(scheduleLink.value)
    notification.info({
      content: t('settings.calendar.copied_to_clipboard'),
      duration: 1 * 1000,
    })
  },
  async copyPermanentLink() {
    copyToClipboard(permanentLink.value)
    notification.info({
      content: t('settings.calendar.copied_to_clipboard'),
      duration: 1 * 1000,
    })
  },
}
</script>
